import React from "react";
import { Box, Heading, VStack } from "@chakra-ui/react";
import { TwoFactorSettings } from "./TwoFactorSettings";
import { AuthenticatedLayout } from "layouts";

const Security: React.FC = () => {
  return (
    <AuthenticatedLayout>
      <Box maxW="600px" mx="auto" py={8} px={4}>
        <VStack spacing={8} align="stretch">
          <Heading size="lg">Security Settings</Heading>
          <TwoFactorSettings />
        </VStack>
      </Box>
    </AuthenticatedLayout>
  );
};

export default Security;
